import { render } from "./Waiting.vue?vue&type=template&id=682ded9b&scoped=true"
import script from "./Waiting.vue?vue&type=script&lang=js"
export * from "./Waiting.vue?vue&type=script&lang=js"

import "./Waiting.vue?vue&type=style&index=0&id=682ded9b&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682ded9b"]])

export default __exports__